import axios from 'axios';
import * as qs from 'qs';
import resolvePath from 'utils/resolvePath';
// Action
const FORWARD = 'conversationHistory/forward';
const CLEAR = 'conversationHistory/clear';
const GET_CONVERSATION_HISTORY_REQUEST = 'conversationHistory/getConversationHistoryRequest';
const GET_CONVERSATION_HISTORY_SUCCESS = 'conversationHistory/getConversationHistorySuccess';
const GET_CONVERSATION_HISTORY_FAILURE = 'conversationHistory/getConversationHistoryFailure';
const GET_CONVERSATION_HISTORY_DETAILS_REQUEST = 'conversation/getConversationHistoryDetailsRequest';
const GET_CONVERSATION_HISTORY_DETAILS_SUCCESS = 'conversation/getConversationHistoryDetailsSuccess';
const GET_CONVERSATION_HISTORY_DETAILS_FAILURE = 'conversation/getConversationHistoryDetailsFailure';
// Action Creator
export const forward = () => {
    return {
        type: FORWARD,
    };
};
export const clear = () => {
    return {
        type: CLEAR,
    };
};
export const getConversationHistoryRequest = () => {
    return {
        type: GET_CONVERSATION_HISTORY_REQUEST,
    };
};
export const getConversationHistorySuccess = (response) => {
    return {
        payload: {
            response,
        },
        type: GET_CONVERSATION_HISTORY_SUCCESS,
    };
};
export const getConversationHistoryFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_CONVERSATION_HISTORY_FAILURE,
    };
};
export const getConversationHistory = (authToken, parameters) => (dispatch) => {
    dispatch(getConversationHistoryRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .get(`${resolvePath.api('history')}?${qs.stringify(parameters)}`, config)
        .then((response) => {
        dispatch(getConversationHistorySuccess(response.data));
    })
        .catch((error) => {
        dispatch(getConversationHistoryFailure(error));
        throw error;
    });
};
export const getConversationHistoryDetailsRequest = () => {
    return {
        type: GET_CONVERSATION_HISTORY_DETAILS_REQUEST,
    };
};
export const getConversationHistoryDetailsSuccess = (response) => {
    return {
        payload: {
            response,
        },
        type: GET_CONVERSATION_HISTORY_DETAILS_SUCCESS,
    };
};
export const getConversationHistoryDetailsFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_CONVERSATION_HISTORY_DETAILS_FAILURE,
    };
};
export const getConversationHistoryDetails = (authToken, partnerId) => (dispatch) => {
    dispatch(getConversationHistoryDetailsRequest());
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    };
    return axios
        .get(`${resolvePath.api(`conversations/conversation_history/${partnerId}`)}`, config)
        .then((response) => {
        dispatch(getConversationHistoryDetailsSuccess(response.data));
    })
        .catch((error) => {
        dispatch(getConversationHistoryDetailsFailure(error));
        throw error;
    });
};
const initialState = {
    conversationHistory: [],
    detailedConversationHistory: {},
    error: null,
    isFetching: false,
    fetching: 0,
    meta: {
        current_page: 0,
        next_page: null,
        per_page: 0,
        previous_page: 0,
        total_entries: 0,
        total_pages: 0,
    },
    page: 1,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case FORWARD: {
            return Object.assign(Object.assign({}, state), { page: state.page + 1 });
        }
        case CLEAR: {
            return Object.assign(Object.assign({}, state), { conversationHistory: [], page: 1 });
        }
        case GET_CONVERSATION_HISTORY_REQUEST: {
            return Object.assign(Object.assign({}, state), { isFetching: true });
        }
        case GET_CONVERSATION_HISTORY_SUCCESS: {
            return Object.assign(Object.assign({}, state), { conversationHistory: state.conversationHistory.concat(action.payload.response.data), isFetching: false, meta: Object.assign({}, action.payload.response.meta) });
        }
        case GET_CONVERSATION_HISTORY_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, isFetching: false });
        }
        case GET_CONVERSATION_HISTORY_DETAILS_REQUEST: {
            return Object.assign(Object.assign({}, state), { fetching: state.fetching + 1 });
        }
        case GET_CONVERSATION_HISTORY_DETAILS_SUCCESS: {
            return Object.assign(Object.assign({}, state), { detailedConversationHistory: Object.assign({}, action.payload.response), fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        case GET_CONVERSATION_HISTORY_DETAILS_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error, fetching: state.fetching > 0 ? state.fetching - 1 : 0 });
        }
        default: {
            return state;
        }
    }
};
